import { createApiDescription } from "../../helperFunctions";

export const deliveredGatherInfo = {
    deleteDeliveredGather: createApiDescription(
        "This API can be called to delete a delivered gather and move it to the recycle bin.",
        [
            "Delete Gather API will be used to delete gather requests present in Delivered Gather report page.",
            "Delete Gather API supports Callback mechanism, callbackUri can be configured in the request body with callback-api-key in the request header. Once a request is sent from Delete Gather API, the response will be posted to the configured callback endpoint URL."
        ]
    ),
    archiveDeliveredGather: createApiDescription(
        "This API can be called to Archive the gather from the Delivered Gather report.",
        [
            "Archive Gather API will be used to archive the Gather request, only if the gather request is present in Delivered Gather report.",
            "Archive Gather API supports Callback mechanism, callback Uri can be configured in the request body with callback-api-key in the request header. Once a request is sent from Archive Return API, the response will be posted to the configured callback endpoint URL."
        ]
    ),
}